module.exports = __webpack_public_path__ + "static/media/costos.fd05f8d2.png";